import { env } from './settings';
import { tasksPath, TaskAttributes, TaskStatus, TaskResultConfirmationStatus } from './registry';
import { throttledConsoleLog } from './Utils';
import { netLog, elasticLogError } from './ElasticLog';
import { getConfig } from '../utils/configUtils';
import { getUseFirestore } from '../constants/Meta';
import { clearFetch } from './Utils';
import sleep from 'sleep-promise';


//for each key, value should fit into `Moxi is ${value}`
const _UntemplatedTasks = {
  moxi_go_to: 'On the move',
  moxi_go_to_charger: 'Going to charge',
  lab_delivery: 'Going to lab',
};

/*
  getUntemplatedStatus returns a status string such that `Moxi is ${status}` makes syntactical sense.
  If task_type is falsey or not a known key of _UntemplatedTasks, undefined is returned.
*/
export function getUntemplatedStatus(task_type) {
  if (!task_type) {
    throttledConsoleLog('getUntemplatedStatus', 'called without task_type');
    return undefined;
  }
  return _UntemplatedTasks[task_type];
}


//Updates task data field on associated task document in firestore.
export async function updateTaskData(taskId, data) {
  if(getUseFirestore()) {
    let newData = {};
    for (var field in data) {
      newData[[TaskAttributes.TASK_DATA, field].join('.')] = data[field];
    }
    // netLog( 'updateTaskData', async () => await env.firestore.collection(tasksPath(env.site)).doc(taskId).update(newData));
    env.firestore.collection(tasksPath(env.site)).doc(taskId).update(newData);  //async
  }
  else {
    //noFS, so farm this out to the mbot backend

    let config = getConfig();
    let siteMbot = config.uiSimServer;
    const backendUrl = new URL('updateTask', siteMbot);

    let options = {
      method: 'PUT',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({taskId, data})
    };

    let done = false, remAttempts = 3;
    while(remAttempts-- >= 0 && !done) {
      await clearFetch(backendUrl, options, {
        success: async (jsonParam) => {
          done = true;
        },
        bad: ({ logStr }) => {
          elasticLogError({what:'remTaskUpFail', msg: `Couldn't update ${taskId.slice(0, 6)}: ${logStr}`, taskId, data, logStr});
        }
      });
      if(!done && remAttempts >= 0)
        await sleep(1000 * 3);
    }
  }
}

export default class Task {
  // returns Task object for firestore task doc with uuid

  //unused
  // static async getTask(uuid) {
  //   let params = await netLog(
  //     'getTask',
  //     async () => await env.firestore.collection(tasksPath(env.site)).doc(uuid).get(),
  //   );
  //   if (!params.exists) return undefined;
  //   return params.data();
  // }

  // returns whether the step has updated between task t1 and task t2
  static _stepUpdated(t1, t2) {
    if (!t1 && !t2) {
      console.log('Task._stepUpdated: neither task was truthy'); //would have caused a crash
      return false;
    }
    return (
      (!t1 && !!t2) ||
      (!!t1 && !t2) ||
      t1.current_step != t2.current_step ||
      (t1.status === TaskStatus.DONE && t2.status === TaskStatus.IN_PROGRESS) ||
      (t1.status !== TaskStatus.CONCLUDED && t2.status === TaskStatus.CONCLUDED)
    );
  }
}

//TODO hoist this and updateTaskData into lib
/*
  Creates an object that can absorb a series of task uuids and 
  asynchronously mark them with supplied data.  Necessary due
  to the absence of the scheduler supporting arbitrary fields
  at task creation time. 

  uuidToTaskFunc needs to supply dynamic (potentially changing 
  over time) access to task data.

  TODO: get scheduler to support related fields on task create,
  so that writing them post-hoc like this is unneeded.
*/
export function makeTaskDecorator(uuidToTaskFunc) {
  let result = {
    _uuidInputComplete: false,
    _undoneUuids: [],

    add: (uuidAndData) => result._undoneUuids.push(uuidAndData),

    allTaskUuidsAdded: () => (result._uuidInputComplete = true),

    isDone: () => {
      result._undoneUuids = result._undoneUuids.filter(({ uuid, data }) => {
        //before marking a given task, wait til the firestore stream
        // confirms that firestore knows about the task.
        let task = uuidToTaskFunc(uuid);
        if (!task) return true; //this uuid stays in the undone list

        updateTaskData(uuid, data); //async, best-effort
        return false;
      });

      return result._uuidInputComplete && !result._undoneUuids.length;
    },
  };
  return result;
}
